/* eslint-disable no-undef */
import $ from "jquery";

const FailedAuth = () => {
    const init = () => {
        email_check();
    };

    const email_check = () => {
        $(document).on(
            "change",
            "#reg_email, .PersoonlijkeGegevens__Form__Input #user-email",
            function () {
                const email = $(this).val();
                const data = {
                    email: email,
                    nonce: user_auth.nonce,
                    action: user_auth.action.check_email,
                };

                $.ajax({
                    type: "POST",
                    url: user_auth.ajaxUrl,
                    data: data,
                })
                    .done(() => {
                        // console.warn(res);
                        $(
                            ".AccountPage__LoginRegister #reg_email_exist",
                        ).hide();
                        $(
                            ".SellTheCar__Button__Next[data-target='others']",
                        ).prop("disabled", false);
                        $(
                            ".PersoonlijkeGegevens__Form__Input #user_email_exist",
                        ).hide();
                    })
                    .fail(() => {
                        $(
                            ".AccountPage__LoginRegister #reg_email_exist",
                        ).show();
                        $(
                            ".SellTheCar__Button__Next[data-target='others']",
                        ).prop("disabled", true);
                        $(
                            ".PersoonlijkeGegevens__Form__Input #user_email_exist",
                        ).show();
                    });
            },
        );
    };

    init();
};

try {
    FailedAuth();
} catch (error) {
    console.error("Auth Failure", error);
}
